import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { useLoginUserMutation } from "../../services/EndPointsApis";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { setPermissionsState, setTheme, setUser } from "../../Features/authslice";
import TextField from "../../core/common/textFields/TextField";
import CryptoJS from 'crypto-js';
import { svgIcons } from "../../style/fonts/SvgIcons";


const Login = () => {
  const route = all_routes;
  const [showPassword, setShowPassword] = useState(true);
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const theme = useSelector((state: any) => state.auth?.theme);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const initialValues = {
    username: "",
    password: "",
  };
  const [loginUser, { data, isError, error, isSuccess, isLoading }] =
    useLoginUserMutation();

  const loginSchema = Yup.object().shape({
    username: Yup.string()
      .email("Wrong email format")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Email is required"),
    password: Yup.string()
      .min(8, "Minimum 8 symbols")
      .max(16, "Maximum 16 symbols")
      .test("uppercase", "Password must contain at least one capital letter", (value) => {
        return /[A-Z]/.test(value || "");
      })
      .test("specialCharacter", "Password must contain at least one special character", (value) => {
        return /[\W_]/.test(value || "");
      })
      .test("number", "Password must contain at least one number", (value) => {
        return /[0-9]/.test(value || "");
      })
      .required("Password is required"),
  });

  // const formik = useFormik({
  //   initialValues,
  //   validationSchema: loginSchema,
  //   onSubmit: (values) => {
  //     loginUser({ ...values, rememberMe });
  //   },
  // });

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,

    onSubmit: (values) => {
      // Define key and iv
      const key = CryptoJS.enc.Utf8.parse('SS#BoQ&IA9NB$&!2');
      const iv = CryptoJS.enc.Utf8.parse('SIV#Bo*QIA9B$!2%');

      // Create user information object
      const userInfo = {
        username: values.username,
        password: values.password,
      };

      // Convert user information object to JSON string
      const userInfoString = JSON.stringify(userInfo);

      // Encrypt user information JSON string
      const encryptedUserInfo = CryptoJS.AES.encrypt(userInfoString, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString();
      loginUser({ userinfo: encryptedUserInfo } as any);
    }

  })

  useEffect(() => {
    if (isSuccess) {
      toast.success(data?.message);
      localStorage.setItem('token', data?.result?.token)
      dispatch(
        setUser({
          ...data?.result?.userAccountBasicInfo,
          // permissions:data?.result?.permissionsList,
          setUser: data?.result?.userAccountBasicInfo,
          token: data?.result?.token,
          expiresAt: data?.result?.expiresAt,
        }),
      );
      dispatch(
        setPermissionsState(data?.result?.permissionsList)
      );
      dispatch(
        setTheme(data?.result?.userAccountBasicInfo?.templateId)
      );
      navigate(route.dealsDashboard);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong';

      if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
  }, [isError, error]);

  const theme2 = localStorage.getItem('theme');

  return (
    <div className="account-content">
      <div className="login-wrapper">
        <div className="login-content">
          <div className="d-flex flex-column justify-content-center h-100 w-100">
            <form onSubmit={formik.handleSubmit} className="w-100">
              <div className="login-user-info">
                <div className="login-logo d-flex justify-content-center">
                  {/* {theme2 !=='light'? */}
                  {/* <ImageWithBasePath
                    src="assets/img/Airoom_Logo_White.png"
                    className=""
                    alt="Logo"
                    width={220}
                    height={68}
                  />
                  : */}
                  <ImageWithBasePath
                    src="assets/img/logo.svg"
                    className=""
                    alt="Logo"
                    width={220}
                    height={68}
                  />
                  {/* } */}
                </div>
                <div className="row justify-content-center">
                  <div className="col-md-8">
                    <div className="login-heading">
                      <h4>Sign In</h4>
                      <p>We are really very happy to see you again!</p>
                    </div>
                    <div className="form-wrap">
                      <div className="form-wrap-icon">
                        <TextField
                          label="Email Address"
                          required
                          type="email"
                          placeholder="Enter Email"
                          {...formik.getFieldProps("username")}
                        />
                        <i className="ti ti-mail" />
                      </div>
                      {formik.touched.username && formik.errors.username && (
                        <div className="error">{formik.errors.username}</div>
                      )}
                    </div>
                    <div className="form-wrap">
                      <div className="pass-group">
                        <TextField
                          label="Password"
                          required
                          type={isPasswordVisible ? "text" : "password"}
                          placeholder="Enter password"
                          {...formik.getFieldProps("password")}
                        />
                        <span
                          className={`ti toggle-password ${isPasswordVisible ? "ti-eye" : "ti-eye-off"
                            }`}
                          onClick={togglePasswordVisibility}
                        ></span>
                      </div>
                      {formik.touched.password && formik.errors.password && (
                        <div className="error">{formik.errors.password}</div>
                      )}
                    </div>
                    <div className="form-wrap form-wrap-checkbox">
                      <div className="custom-control custom-checkbox">
                        <label className="check">
                          <input
                            type="checkbox"
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                          />
                          <span className="box" /> Remember Me
                        </label>
                      </div>
                      <div className="text-end">
                        <Link to={route.forgotPassword} className="forgot-link">
                          Forgot Password?
                        </Link>
                      </div>
                    </div>
                    <div className="form-wrap">
                      <button type="submit" className="btn btn-primary"
                      // disabled
                      >
                        {isLoading ? "Signing In...." : "Sign In"}
                      </button>
                    </div>
                    <h6 className="mt-3 text-center">OR</h6>
                    <div className=" mt-3 d-flex justify-content-center">
                      {/* for dev  */}
                      {/* <a href="https://login.microsoftonline.com/88e858d7-7890-4eda-9336-0120d3bcf246/oauth2/v2.0/authorize?
client_id=c08adde5-741a-42d2-bda9-ae3bd8b55cb8&response_type=token&
redirect_uri=https://afdportaldev.azurewebsites.net/auth&scope=openid profile email&response_mode=fragment" className="btn btn-light border border-1">
                        <span className="me-2">{svgIcons?.microsoft}</span>
                        {"Continue With Microsoft"}
                      </a> */}

                      {/* for uat */}
                      {/* <a href="https://login.microsoftonline.com/88e858d7-7890-4eda-9336-0120d3bcf246/oauth2/v2.0/authorize?client_id=50f1daaf-2dfc-469a-a4d9-e4f627c4ebbd&response_type=token&redirect_uri=https://afdportaluat.azurewebsites.net/auth&scope=openid profile email&response_mode=fragment" className="btn btn-light border border-1">
                        <span className="me-2">{svgIcons?.microsoft}</span>
                        {"Continue With Microsoft"}
                      </a> */}

                      {/* for prd */}
                      <a href="https://login.microsoftonline.com/88e858d7-7890-4eda-9336-0120d3bcf246/oauth2/v2.0/authorize?client_id=4dad253b-9c6c-4e97-846f-f4ad57258d8d&response_type=token&redirect_uri=https://afdportalprd.azurewebsites.net/auth&scope=openid profile email&response_mode=fragment" className="btn btn-light border border-1">
                        <span className="me-2">{svgIcons?.microsoft}</span>
                        {"Continue With Microsoft"}
                      </a>

                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="copyright-text">
            <p className="mb-5">Copyright ©1958 - AIROOM</p>
          </div>
        </div>
        <div className="w-50 login-img"></div>
      </div>
    </div>
  );
};

export default Login;
